import Chart, { plugins } from 'chart.js/auto';

export function initChart(){

	/////////// text for the chart legened. shorten it up on a mobile.

  if ( $(window).width() < 768 ) {
    var granularNLabel = "Granular N"
    var foliarNLabel = "Foliar N"
    var coldLabel = "Cold"
  };

  if ( $(window).width() >= 768 ) {
    var granularNLabel = "Granular N Turf Response"
    var foliarNLabel = "Foliar N Turf Response"
    var coldLabel = "Cold (N release restriction)"
  };

  var str = new String("Demo Text");

  switch(chartData.units) {
    case 'imperial':
      var labelString = 'lbs/1000 ft\u00B2';
      break;
    case 'metric':
      var labelString = 'kg/100 m\u00B2';
      break;
    default:
  }

  // stacked bars and unstacked lines on same axis reference
  // https://stackoverflow.com/questions/34929095/chartjs-2-stacked-bar-and-unstacked-line-on-same-chart-with-same-y-axis

  // keeping topEndArray to give the chart a little spatial headroom

  // chart & options


  config = {
      type: 'bar',
      data: {
          labels: weeksArray,
          datasets: [
            {
              label: "Carryover N",
              data: chartData.avgCO,
              backgroundColor: 'rgba(255, 165, 0, 1)',
              borderWidth: 0,
              type: 'bar',
              stack: 'Stack 0',
              order: 1
            },
            {
              label: granularNLabel,
              data: chartData.avgG,
              backgroundColor: 'rgba(0, 122, 51, 1)',
              borderWidth: 0,
              type: 'bar',
              stack: 'Stack 0',
              order: 2
            },
            {
              label: foliarNLabel,
              data: chartData.avgL,
              backgroundColor: 'rgba(0, 169, 206, 1)',
              borderWidth: 0,
              type: 'bar',
              stack: 'Stack 0',
              order: 3
            },
            {
              label: coldLabel,
              type: 'line',
              data: chartData.coldArray,
              backgroundColor: 'rgba(230, 231, 232, .75)',
              borderWidth: 0,
              fill: true,
              order: 4
            },
            {
              label: 'Target N',
              type: 'line',
              data: chartData.targetArray,
              borderColor: 'rgba(0, 0, 0, 1)',
              borderWidth: 1,
              fill: false,
              order: 5
            },
            // {
            //   label: 'Max economical N release',
            //   type: 'line',
            //   data: chartData.topEndArray,
            //   borderColor: 'rgba(0, 128, 0, 0)',
            //   borderWidth: 1.5,
            //   fill: false,
            //   order: 6
            // }
          // ,
          // {
          //   label: 'Min N for green up',
          //   type: 'line',
          //   data: chartData.lowEndArray,
          //   borderColor: 'rgba(255, 0, 0, 0)',
          //   borderWidth: 1.5,
          //   fill: false
          // }
          // ,{
          //   label: 'N Soil Release',
          //   type: 'line',
          //   data: chartData.tempEffects,
          //   borderColor: 'rgba(20, 200, 200, 0)',
          //   borderWidth: 2,
          //   fill: false
          // }
          ]
      },
      options: {
          responsive: true,
          onResize: function(chart,size){
            //console.log(size);
          },
          maintainAspectRatio: false,
          plugins: {           
            tooltip: {
              // don't display tooltips for 0 values
              filter: function (tooltipItem) {
                var val = tooltipItem.dataset.data[tooltipItem.dataIndex];
                if (val === 0 ) {
                  return false;
                } else {
                  return true;
                }
              }
            },
            htmlLegend: {
              // ID of the container to put the legend in
              containerID: 'chart-legends',
            },
            legend: {
              display: false,
              position: "top",
              labels: {
                filter: function(item, chart) {
                    // Logic to remove a particular legend item goes here
                    //return !item.text.includes('label to remove');
                    //console.log(item)
                    if (item.text=="Top End" || item.text=="Low End" || item.text=="Target N") {
                      return !item
                    }
                    if (item.text=="Target N" || item.text=="N Soil Release") {
                      item.fillStyle = "rgba(255,255,255,1.0)"
                    }
                    item.lineWidth = 3
                    return item;
                }
              }
            },
          },
          legendCallback: function(chart) {
              var text = [];
              text.push('<div class="upper">')
              for (var i = 0; i < chart.data.datasets.length; i++) {
                text.push('<div class="legend-block">')
                  if (i==0||i==1||i==2||i==3||i==4) {
                    if (chart.data.datasets[i].backgroundColor && chart.data.datasets[i].data.length) {
                      text.push('<span class="legend-chip square" style="background-color:' +
                               chart.data.datasets[i].backgroundColor +
                               '"></span>');
                    }
                    if (chart.data.datasets[i].borderColor && chart.data.datasets[i].data.length) {
                      text.push('<span class="legend-chip line" style="background-color:' +
                               chart.data.datasets[i].borderColor +
                               '"></span>');
                    }
                    if (chart.data.datasets[i].label && chart.data.datasets[i].data.length ) {
                        text.push('<small class="text-muted">' + chart.data.datasets[i].label.split(' ').join('&nbsp;') + '</small>');
                    }
                  }
                text.push('</div>')
              }
              text.push('</div>')

              // want two rows? adjust here.


              // text.push('<div class="lower">')
              // for (var i = 0; i < chart.data.datasets.length; i++) {
              //     if (i==2||i==3) {
              //       if (chart.data.datasets[i].backgroundColor) {
              //         text.push('<span class="legend-chip square" style="color:' +
              //                  chart.data.datasets[i].backgroundColor +
              //                  '">&#9632;</span>');
              //       }
              //       if (chart.data.datasets[i].borderColor) {
              //         text.push('<span class="legend-chip line" style="color:' +
              //                  chart.data.datasets[i].borderColor +
              //                  '">&#9472;</span>');
              //       }
              //       if (chart.data.datasets[i].label) {
              //           text.push('<small class="text-muted">' + chart.data.datasets[i].label + '</small>');
              //       }
              //     }
              // }
              // text.push('</div>')
              return text.join('');
          },
          elements: {
            // don't display points for line data
            point: {
              radius: 0,
              hitRadius: 0,
              hoverRadius: 0,
              hoverBorderWidth: 0
            }
          },
          scales: {
            x: {
                offset: false, // don't add the extra space(s) on the ends
                display: true,
                stacked: true,
                grid: {
                  display: false
                },
            },
            y: {
                  ticks: {
                      stepSize: ( chartData.targetValue / 3 )
                  },
                  title: {
                    display: true,
                    text: labelString
                  }
            }
          }
        },
      plugins: [htmlLegendPlugin]
      }

	canvas = document.getElementById("chart");
	chart = new Chart(canvas, config);

  pdfCanvas = document.getElementById("pdf-chart");
  pdfChart = new Chart(pdfCanvas, config);

	// document.getElementById('chart-legends').innerHTML = mychart.generateLegend();
  
}




const getOrCreateLegendDiv = (chart, id) => {
  const legendContainer = document.getElementById(id);
  let legendDiv = legendContainer.querySelector('.upper');

  if (!legendDiv) {
    legendDiv = document.createElement('div');
    legendDiv.className = 'upper';
    legendContainer.appendChild(legendDiv);
  }

  return legendDiv;
};

const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart, args, options) {
    const legendDiv = getOrCreateLegendDiv(chart, options.containerID);

    // Remove old legend items
    while (legendDiv.firstChild) {
      legendDiv.firstChild.remove();
    }

    // Reuse the built-in legendItems generator
    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    items.forEach((item, i) => {
      // Only show legend for datasets with data
      if (!chart.data.datasets[i] || !chart.data.datasets[i].data.length) return;

      const blockDiv = document.createElement('div');
      blockDiv.className = 'legend-block';
      blockDiv.style.display = 'inline-block';
      blockDiv.style.marginRight = '10px';
      blockDiv.style.cursor = 'pointer';

      blockDiv.onclick = () => {
        const {type} = chart.config;
        if (type === 'pie' || type === 'doughnut') {
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(item.datasetIndex, !chart.isDatasetVisible(item.datasetIndex));
        }
        chart.update();
      };

      // Color chip (square or line)
      if (chart.data.datasets[i].backgroundColor) {
        const chip = document.createElement('span');
        chip.className = 'legend-chip square';
        chip.style.backgroundColor = chart.data.datasets[i].backgroundColor;
        chip.style.display = 'inline-block';
        chip.style.marginRight = '5px';
        blockDiv.appendChild(chip);
      }
      if (chart.data.datasets[i].borderColor) {
        const chip = document.createElement('span');
        chip.className = 'legend-chip line';
        chip.style.backgroundColor = chart.data.datasets[i].borderColor;
        chip.style.display = 'inline-block';
        chip.style.marginRight = '5px';
        blockDiv.appendChild(chip);
      }

      // Label text
      if (chart.data.datasets[i].label) {
        const label = document.createElement('small');
        label.className = 'text-muted';
        label.innerHTML = chart.data.datasets[i].label.split(' ').join('&nbsp;');
        blockDiv.appendChild(label);
      }

      legendDiv.appendChild(blockDiv);
    });
  }
};